export default __webpack_public_path__ + "static/media/weekly_accuracy_empty.1bfbac5d.svg";